<template>
  <div>
    <el-dialog
      class="modal"
      title="刪除"
      :visible.sync="delModal"
      width="375px"
    >
      <div>是否刪除 {{ currentData.name }}</div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="delModal = false" class="btn">取消</div>
        <div @click="confirmDel" class="btn">確認</div>
      </div>
    </el-dialog>
    <p class="text-danger">
      請勿大量建立無意義通道，經查實一律封號處理。
    </p>
    <el-form
      :inline="true"
      :model="searchData"
      class="demo-form-inline"
      style="width: 100%;margin-top:18px"
    >
      <el-form-item label="模板名稱">
        <el-input v-model="name" placeholder="模板名稱"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="setModal">新增模板</el-button>
      </el-form-item>
    </el-form>
    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        header-align="center"
        align="center"
        prop="name"
        label="名稱"
      >
        <template slot-scope="scope">
          <div>
            <el-input v-model="scope.row.name"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="name"
        label="操作"
      >
        <template slot-scope="scope">
          <div>
            <el-button size="mini" @click="renewModal(scope.row)"
              >更新模板</el-button
            >
            <el-button size="mini" @click="deltModal(scope.row)"
              >刪除</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="name"
        label="使用"
      >
        <template slot-scope="scope">
          <div>
            <el-switch
              @change="
                scope.row.status == 1
                  ? (scope.row.status = 0)
                  : (scope.row.status = 1)
              "
              :value="scope.row.status == 1"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-form
        :inline="true"
        :model="{}"
        class="demo-form-inline"
        style="width: 100%;margin-top:18px"
      >
        <el-form-item label="商戶號">
          <el-input v-model="customer_id" placeholder="請輸入商戶號"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addModal">批量添加通道</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      dataList: [],
      searchData: {},
      currentData: {},
      delModal: false,
      customer_id: ""
    };
  },
  methods: {
    addModal() {
      let models = [];
      models = this.dataList.filter(e => {
        return e.status == 1;
      });
      if (!this.customer_id) {
        this.$message.error("請輸入商戶號");
        return;
      }
      this.$http
        .post(`/back/collection_method/models/set`, {
          models,
          customer_id: this.customer_id
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.customer_id = "";
          }
        });
    },
    confirmDel() {
      this.$http
        .delete(`/back/collection_method/models/${this.currentData.id}`)
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.getData();
            this.delModal = false;
          }
        });
    },
    deltModal(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.delModal = true;
    },
    renewModal(data) {
      this.$http
        .put(`/back/collection_method/models/${data.id}`, {
          name: data.name,
          status: data.status
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.getData();
          }
        });
    },
    setModal() {
      if (!this.name) {
        this.$message.error("請輸入名稱");
        return;
      }
      this.$http
        .post(`/back/collection_method/models`, {
          name: this.name
        })
        .then(res => {
          if (res.data.code == 0) {
            this.getData();
          }
        });
    },
    getData() {
      this.$http.get(`/back/collection_method/models`).then(res => {
        if (res.data.code == 0) {
          this.dataList = res.data.data;
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
